import Badge, { BadgeProps } from "@mui/material/Badge";
import { styled } from "@mui/material/styles";
import { misc } from "app/themes/colors";

const BottomRightDotBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
  "& .MuiBadge-badge": {
    right: -6,
    top: 24,
    padding: "0 4px",
    background: misc.warningText,
  },
}));

export default BottomRightDotBadge;
